export default "__VITE_ASSET__561273aa__"